export const environment = {
  production: false,

  //common
  WarningMessage: "No information found.",
  ErrorMessage:
    "Unable to retrieve the information at this  time. Please try again later.",
  inputTypeTextPattern: "^[a-zA-Z-]*$",
  emailPattern: "^[A-Za-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$",
  phonePattern: "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[ s./0-9]*$",
  inputTypeTextNumberPattern: "^[a-zA-Z0-9_]*$",
  passwordPattern: "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}",

	//cromwell live
   Version: "1.0.1",
   clinicName: "Cromwell Place Dental Practice",
   primaryColor: "#764e91",
   secondaryColor: "#00b3cd",
   logoImage: "Logo.png",
   smallLogo: "logo-small.svg",
  configUrl: "https://liveapi.cromwellplacedental.co.uk/",
  configSocketUrl: "https://chatapi.cromwellplacedental.co.uk/",
  configSocketUrlStaff: "https://chatapi.cromwellplacedental.co.uk/", 
  webUrl: "https://admin.cromwellplacedental.co.uk/",
  websiteUrl: "https://cromwellplacedental.co.uk/",
  addresApiKey: "H6dwt1VShE2iwKo1yvxPRw31608",
  bankVerificationKey: "CJ58-BB63-XK13-ZT19",
  favIcon: "https://admin.cromwellplacedental.co.uk/favicon.ico",
  PMSName: "Dentally",
  PrincipalDentistName: "Dr Jai Pratap Reddy",
  webToken: "A3CDDB35-3AA3-44B6-A5FE-99478719545F",

  
};
